import { render, staticRenderFns } from "./ProfileTransferStoreForms.vue?vue&type=template&id=32c19b88"
import script from "./ProfileTransferStoreForms.vue?vue&type=script&lang=js"
export * from "./ProfileTransferStoreForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports